/* unplugin-vue-components disabled */import { render } from "./FormRender.vue?vue&type=template&id=05434584&ts=true"
import script from "./FormRender.vue?vue&type=script&lang=ts"
export * from "./FormRender.vue?vue&type=script&lang=ts"

import "./FormRender.vue?vue&type=style&index=0&id=05434584&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__